module.exports = __webpack_public_path__ + "static/media/arrow.c50c83d5.png";